import Joi from "joi";

const schemaNoUrl = Joi.object({
  name: Joi.string()
    .required()
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "string.empty":
            err.message = "テーブル名を入力してください。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
  seats: Joi.number()
    .unsafe()
    .required()
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "number.base":
            err.message = "席数を入力してください。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
  detail: Joi.string()
    .required()
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "string.empty":
            err.message = "備考を入力してください。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
}).options({ abortEarly: false });

const schemaWithUrl = Joi.object({
  name: Joi.string()
    .required()
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "string.empty":
            err.message = "テーブル名を入力してください。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
  image: Joi.string()
    .regex(
      //eslint-disable-next-line
      /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
    )
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "string.pattern.base":
            err.message = "このURLはYoutubeのURLではありません。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
  detail: Joi.string()
    .required()
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "string.empty":
            err.message = "備考を入力してください。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
  seats: Joi.number()
    .unsafe()
    .required()
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "number.base":
            err.message = "席数を入力してください。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
}).options({ abortEarly: false });

const schemaValidateLinkYoutube = Joi.object({
  image: Joi.string()
    .allow("")
    .regex(
      //eslint-disable-next-line
      /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
    )
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "string.pattern.base":
            err.message = "このURLはYoutubeのURLではありません。";
            break;
          default:
            break;
        }
      });
      return errors;
    }),
}).options({ abortEarly: false });

export { schemaNoUrl, schemaWithUrl, schemaValidateLinkYoutube };
